import * as React from 'react';

var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgPinterestIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#BD081C",
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.8 323.2c-18.9 0-36.6-10.2-42.6-21.8 0 0-10.1 40.2-12.3 48-7.6 27.4-29.8 54.9-31.5 57.1-1.2 1.6-3.9 1.1-4.1-1-.5-3.5-6.1-38.1.5-66.3 3.3-14.2 22.5-95.1 22.5-95.1s-5.6-11.1-5.6-27.6c0-25.9 15-45.2 33.7-45.2 15.9 0 23.5 11.9 23.5 26.2 0 16-10.2 39.8-15.4 61.9-4.4 18.5 9.3 33.6 27.5 33.6 33.1 0 55.3-42.5 55.3-92.8 0-38.3-25.8-66.9-72.6-66.9-52.9 0-86 39.5-86 83.6 0 15.2 4.5 25.9 11.5 34.2 3.2 3.8 3.7 5.4 2.5 9.7-.9 3.2-2.8 11-3.6 14-1.2 4.4-4.8 6-8.8 4.4-24.4-9.9-35.7-36.7-35.7-66.7 0-49.6 41.8-109 124.8-109 66.7 0 110.5 48.2 110.5 100 .1 68.6-38 119.7-94.1 119.7z",
    fill: "#FFF"
  }))));
}

export { SvgPinterestIcon as default };
